// Un contenedor cuya altura se acomoda con una transición cuando cambia lo de adentro
// (ADR-2026-10-09-asistente-en-crear-2). Lo usa la portada de Crear al pasar del título y
// las plantillas a la demo del Asistente: sin esto, la caja de abajo saltaba de lugar.
//
// Mide el contenido con un `ResizeObserver` y le pone esa altura al envoltorio. Anima SÓLO
// un momento después de que cambia `clave` (la pestaña): el resto del tiempo sigue al
// contenido sin demora, porque lo de adentro puede animar su propia altura (la demo al
// achicarse) y dos transiciones encadenadas se arrastraban. No recorta: lo nuevo entra con
// su propio fundido.

import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import './crear.css';

const DURACION_MS = 480;

export const AlturaSuave: React.FC<{ clave: string; children: React.ReactNode; className?: string }> = ({ clave, children, className = '' }) => {
  const adentroRef = useRef<HTMLDivElement | null>(null);
  const [alto, setAlto] = useState<number | null>(null);
  const [animando, setAnimando] = useState(false);
  const claveRef = useRef(clave);
  useLayoutEffect(() => {
    const nodo = adentroRef.current;
    if (!nodo) return;
    setAlto(nodo.offsetHeight);
    if (typeof ResizeObserver === 'undefined') return;
    const ro = new ResizeObserver(([e]) => setAlto(e?.borderBoxSize?.[0]?.blockSize ?? nodo.offsetHeight));
    ro.observe(nodo);
    return () => ro.disconnect();
  }, []);
  // Cambió la pestaña: la próxima medida (la del contenido nuevo) se anima.
  if (claveRef.current !== clave) {
    claveRef.current = clave;
    if (!animando) setAnimando(true);
  }
  useEffect(() => {
    if (!animando) return;
    const t = window.setTimeout(() => setAnimando(false), DURACION_MS);
    return () => window.clearTimeout(t);
  }, [animando, clave]);
  return (
    <div className={`${animando ? 'crear-altura' : ''} ${className}`} style={alto === null ? undefined : { height: alto }}>
      {/* `flow-root`: los márgenes de lo de adentro cuentan en la medida (no se escapan). */}
      <div ref={adentroRef} className="flow-root">
        {children}
      </div>
    </div>
  );
};

export default AlturaSuave;
